import { Injectable } from '@angular/core';
import { DBSchema } from 'idb';
import { IdbFactory } from '@libs/factory/idb/idb.factory';
import {
    CLIENTS_SUPPORT_DB_NAME,
    CLIENTS_SUPPORT_DB_VERSION,
    CLIENTS_SUPPORT_TABLE_NAME,
} from '../../../app.constants';
import { GetClientDataIdResponse } from '@api/models/ClientSupportApi/Contract/get-client-data-id-response';


interface ClientsDB extends DBSchema {
    clients: {
        value: GetClientDataIdResponse & { sort?: number };
        key: string;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        indexes: { 'by-id': number };
    };
}


@Injectable({
    providedIn: 'root',
})
export class IdbClientService {
    idb: IdbFactory<ClientsDB, GetClientDataIdResponse> = new IdbFactory<ClientsDB, GetClientDataIdResponse>(
        CLIENTS_SUPPORT_DB_NAME,
        CLIENTS_SUPPORT_DB_VERSION,
        CLIENTS_SUPPORT_TABLE_NAME,
    );
}
